import cx from "classnames";
import dynamic from "next/dynamic";
import useSticky from "../../../../../utils/useSticky";
import AvailableTomorrow from "../AvailableTomorrow";
const Price = dynamic(() => import("../../../../Atoms/Price"), { ssr: false });

interface Props {
  topOffset: number;
  stopEl: any;
  children: any;
}

export function StickyBottomBar({ topOffset, stopEl, children }: Props) {
  const isSticky = useSticky(topOffset, stopEl);
  const classNames = cx({
    "mui-detailStickyContainer": true,
    "mui-detailStickyContainerShow": isSticky,
  });

  return <div className={classNames}>{children}</div>;
}

interface BarProps {
  name: string;
  productId: string;
  isAvailable: boolean;
  onSelectDates: () => void;
}

export function BotBar({
  name,
  isAvailable,
  productId,
  onSelectDates,
}: BarProps) {
  return (
    <div className="AppTopBar">
      <div className="AppLayout">
        <div className="TopBarDetailInner">
          <h3>{name}</h3>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Price id={productId} />
            <AvailableTomorrow productId={productId} />
          </div>

          <button
            className="Button"
            disabled={!isAvailable}
            onClick={onSelectDates}
          >
            Select Dates
          </button>
        </div>
      </div>
    </div>
  );
}
